@if(readonly()){
<div class="mb-3">
	<common-message alertType="info">You have readonly access to this content.</common-message>
</div>
}